import { enumToOptions } from "./util";

export enum VoucherSecondaryDiagnosisReportingTypeEnum {
    NOT_REPORTED = 'notReported',
    TO_VOUCHER_AND_BATCH = 'toVoucherAndBatch',
    TO_BATCH = 'toBatch',
}

export const voucherSecondaryDiagnosisReportingTypeEnumOptions = enumToOptions(VoucherSecondaryDiagnosisReportingTypeEnum, 'voucher.general.secondaryDiagnoses.reportingType.');
